import { config } from 'src/config';

export const LS_AUTH_TOKEN_KEY = `oidc.user:${config.OIDC_URL}:${config.OIDC_CLIENT_ID}`;

export const OIDC_ROUTES = {
  unauthorized: 'unauthorized',
  signinCallback: 'signin-callback',
  signoutCallback: 'signout-callback',
};
